module.exports = __webpack_public_path__ + "img/disney_activity.97a7f872.png";